import { Input } from './input';
import { Node } from '../base/node';
import { Branch } from '../base/branch';
import { Category } from './category';

export class Type extends Node {
    static _type: string = 'Type';

    inputId?: string;
    input?: Input;
    data: any;
    graphqlType?: string;

    constructor(source?: any) {
        super(source);

        if (source) {
            this.inputId = source.inputId;
            this.data = source.data;
            this.graphqlType = source.graphqlType;
            this.input = new Input(source.input);
        }
    }

    copy(source?: any) {
        super.copy(source);

        if (source) {
            this.inputId = source.inputId;
            this.data = source.data;
            this.graphqlType = source.graphqlType;
            this.input = new Input(source.input);
        }
    }

    get model(): any {
        const { input, ...rest } = super.model;
        return rest;
    }

    override fit(branch: Branch): boolean {
        return branch instanceof Category;
    }
}
